
<div class="row">
  <div class="col-lg-12 grid-margin">
    <div class="card">
      <div class="card-body upper-header" >
        <h4 class="card-title" *ngIf="!isEditMode">Add Media</h4>
        <h4 class="card-title" *ngIf="isEditMode">Edit Media</h4>

        <div class="filter-wrapper field_space" *ngIf="form">
          <form [formGroup]="form">
            <div class="form-group col-12-div">

              <div class="form-group col-4-div">
                <label >Category*</label>
                <select class="form-control border-primary" name="category" formControlName="category">
                  <option value="">select</option>
                  <option *ngFor="let cat of categories" [value]="cat">{{cat}}</option>
                </select>
                <div class="" *ngIf="form.controls.category.touched && !form.controls.category.valid">
                  <div class="inaild_no" *ngIf="form.controls.category.errors.required">Category is required!</div>
                </div>
              </div>

              <div class="form-group col-4-div">
                <label >Date*</label>
                <input type="date" class="form-control border-primary" name="date" formControlName="date">
                <div class="" *ngIf="form.controls.date.touched && !form.controls.date.valid">
                  <div class="inaild_no" *ngIf="form.controls.date.errors.required">Date is required!</div>
                </div>
              </div>

              <div class="form-group col-4-div">
                <label >Media Type*</label>
                <select class="form-control border-primary" name="mediaType" formControlName="media_type">
                  <option value="">select</option>
                  <option *ngFor="let type of mediaTypes" [value]="type.value">{{type.label}}</option>
                </select>
                <div class="" *ngIf="form.controls.media_type.touched && !form.controls.media_type.valid">
                  <div class="inaild_no" *ngIf="form.controls.media_type.errors.required">Media Type is required!</div>
                </div>
              </div>

              <div class="form-group col-4-div">
                <label >Select Media* (Multiple files allowed)</label>
                <input type="file" class="form-control border-primary" name="mediaFile" (change)="onFileSelect($event)" [accept]="form.get('media_type').value === 'image' ? 'image/*' : 'video/*'" multiple [disabled]="!form.valid || isUploading">
                <small class="form-text text-muted">
                  Max file size: 500MB per file. Files will be uploaded automatically after selection.
                </small>
              </div>

            </div>

             <!-- Uploaded Media List -->
        <div class="uploaded-media-section" *ngIf="uploadedMedia.length > 0">
          <hr>
          <h5>Uploaded Media ({{uploadedMedia.length}})</h5>
          <div class="row">
            <div class="col-md-3 mb-3" *ngFor="let media of uploadedMedia; let i = index">
              <div class="media-item card">
                <div class="media-preview-container">
                  <img *ngIf="media.media_type === 'image'" 
                    [src]="media.thumbnail_url || media.media_url" 
                    [alt]="'Media ' + (i + 1)"
                    class="media-preview">
                  <div *ngIf="media.media_type === 'video'" class="video-preview">
                    <img [src]="media.thumbnail_url" [alt]="'Video ' + (i + 1)" class="media-preview">
                    <div class="video-overlay">
                      <i class="fa fa-play-circle"></i>
                    </div>
                  </div>
                  <button type="button" 
                    class="btn btn-sm btn-danger remove-btn" 
                    (click)="removeUploadedMedia(i)"
                    title="Remove">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="media-info">
                  <i class="fa {{getMediaTypeIcon(media.media_type)}}"></i>
                  <span>{{media.media_type === 'video' ? 'Video' : 'Image'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

            <!-- Action Buttons -->
            <div class="button-wrap" *ngIf="uploadedMedia.length > 0">
              <button type="button" 
                class="btn btn-primary btn-fw" 
                (click)="submitMedia()">
                {{isEditMode ? 'Update' : 'Submit'}} 
              </button>
              
              <button type="button" 
                class="btn btn-secondary btn-fw" 
                (click)="cancel()">
                Close
              </button>
            </div>
          </form>
        </div>

        <!-- Upload Progress -->
        <div class="progress-section" *ngIf="isUploading">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated" 
              role="progressbar" 
              [style.width.%]="uploadProgress">
              {{uploadProgress}}%
            </div>
          </div>
        </div>

       
      </div>
    </div>
  </div>
</div>
